import { GET_PRIZES_SUCCESS, GET_PRIZES_FAIL, ADD_REDEMPTION_SUCCESS, ADD_REDEMPTION_FAIL, GET_REDEMPTIONS_ACTIVITY_SUCCESS, GET_REDEMPTIONS_ACTIVITY_FAIL, ADD_ACTIVITY_SUCCESS, ADD_ACTIVITY_FAIL } from "./actionTypes"

const INIT_STATE = {
  coins: "",
  prizes: [],
  redemptions: [],
  activity: [],
  error: {},
}

const plantstore = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_PRIZES_SUCCESS:
      return {
        ...state,
        prizes: action.payload,
      }

    case GET_PRIZES_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_REDEMPTIONS_ACTIVITY_SUCCESS:
      return {
        ...state,
        redemptions: action.payload.redemptions,
	activity: action.payload.activity,
	coins: action.payload.coins
      }

    case GET_REDEMPTIONS_ACTIVITY_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case ADD_REDEMPTION_SUCCESS:
      return {
	...state,
        redemptions: action.payload.redemptions,
        coins: action.payload.coins
      }
    case ADD_REDEMPTION_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case ADD_ACTIVITY_SUCCESS:
      return {
        ...state,
        activity: action.payload.activity,
        coins: action.payload.coins
      }
    case ADD_ACTIVITY_FAIL:
      return {
        ...state,
        error: action.payload,
      }


    default:
      return state
  }
}

export default plantstore 
